export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9693.d0f0dba1.jpg";